import React from 'react';
import { DeleteFilled } from '@ant-design/icons';
import Typo from 'consts/typography';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import { removeAllBets, removeAllFutureBets } from 'features/home/homeSlice';
import { uniqueId } from 'utils/commonUtils';
import { platformStates } from 'redux/platformSlice';
import { removeAllTeasers } from 'redux/teaserSlice';

interface BetSlipTabProps {
  currentTab: number;
  changeTab: (tab: number) => void;
  resetCombo: () => void;
}

const BetSlipTab: React.FunctionComponent<BetSlipTabProps> = ({
  currentTab,
  changeTab,
  resetCombo,
}) => {
  const dispatch = useAppDispatch();
  const t = useAppTranslation();
  const { isPhone, isTablet, isDesktop } = useAppSelector(platformStates);
  const onDeleteAllBet = () => {
    dispatch(removeAllBets());
    dispatch(removeAllFutureBets());
    dispatch(removeAllTeasers());
    resetCombo();
  };

  const onChangeActiveTab = (value: number) => {
    if (value !== 3) {
      changeTab(value);
    } else {
      onDeleteAllBet();
    }
  };
  const textButtons = [
    {
      value: 1,
      label: t('betSlipTab.single'),
      grow: 5,
    },
    {
      value: 2,
      label: t('betSlipTab.combo'),
      grow: 5,
    },
    {
      value: 4,
      label: t('betSlipTab.teaser'),
      grow: 5,
    },
    {
      value: 3,
      label: <DeleteFilled style={{ fontSize: '16px' }} />,
      grow: 1,
      padding: 10,
    },
  ];

  return (
    <div className="w-full flex flex-row items-center justify-between bet-slip-tab ">
      {textButtons.map((x) => (
        <button
          key={uniqueId()}
          className={`cursor-pointer truncate-text ${
            isPhone ? Typo.p5 : isTablet ? Typo.p3 : isDesktop ? Typo.p6 : Typo.p1
          } ${currentTab === x.value ? 'active' : ''}`}
          style={{ flexGrow: x.grow, padding: x.padding }}
          onClick={() => onChangeActiveTab(x.value)}
        >
          {x.label}
        </button>
      ))}
    </div>
  );
};

export default BetSlipTab;
